// Abre um documento da API (PDF, XML) numa nova aba usando o login do
// usuário. As rotas de documento não são mais públicas: sem login só abrem
// com link assinado (QR code), então não dá para usar window.open direto.
export default async function abrirDocumento(path, nome = "documento") {
  // Abre a aba já no clique para o navegador não bloquear o popup.
  const janela = window.open("", "_blank");

  try {
    const token = localStorage.getItem("@primefrutas/token");
    const resposta = await fetch(process.env.REACT_APP_API_URL + path, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!resposta.ok) {
      let mensagem = resposta.statusText;
      try {
        const data = await resposta.json();
        mensagem = data.message || data.msg || data.error || mensagem;
      } catch (e) {
        // resposta sem JSON
      }
      throw new Error(mensagem);
    }

    const url = URL.createObjectURL(await resposta.blob());
    if (janela) janela.location.href = url;
    else window.open(url, "_blank");
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (error) {
    janela?.close();
    alert(`Erro ao abrir ${nome}: ${error.message}`);
  }
}
